module.exports = __webpack_public_path__ + "fonts/Driftwood2.bf209aea.otf";